import { useState } from 'react';
import { logoutMe, mapUserMeType, useFindOwnUserSuspense } from '@api';
import { LegacyAnchor } from '@common';
import { faChevronCircleDown } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Avatar, Button, Center, Flex, Popover, Text } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import portraitPlaceholder from 'src/assets/img/portrait_placeholder.png';
import styles from './UserProfile.module.css';

export const UserProfile: React.FC = () => {
  const { t } = useTranslation();
  const { data: userData } = useFindOwnUserSuspense({
    query: { select: (data) => mapUserMeType(data.data) },
  });

  const [opened, setOpened] = useState(false);

  const navigate = useNavigate();

  const handleLogout = () => {
    logoutMe();
    setOpened(false);
    navigate({ to: '/login' });
  };

  return (
    <Flex align="center" gap="sm" mr="sm">
      <LegacyAnchor href="/profile">
        <Center>
          <Avatar
            src={portraitPlaceholder}
            alt={`${userData.firstname} ${userData.lastname}`}
            size={22}
            radius="xl"
            mr={4}
          />
          <Text fw={700} className={styles.userProfileUserName}>
            {userData.firstname}
          </Text>
        </Center>
      </LegacyAnchor>

      {/* TODO: Replace LegacyAnchor with Link when we have the new profile page */}

      {/* <Link to="/profile" className={styles.userProfileLink}>
        <Center>
          <Avatar
            src={portraitPlaceholder}
            alt={`${userData.firstname} ${userData.lastname}`}
            size={22}
            radius="xl"
            mr={4}
          />
          <Text fw={700} className={styles.userProfileUserName}>
            {userData.firstname}
          </Text>
        </Center>
      </Link> */}
      <Popover
        opened={opened}
        onChange={setOpened}
        position="bottom-end"
        offset={12}
      >
        <Popover.Target>
          <FontAwesomeIcon
            icon={faChevronCircleDown}
            size="lg"
            className={styles.userProfileDropdown}
            onClick={() => setOpened(!opened)}
          />
        </Popover.Target>
        <Popover.Dropdown style={{ padding: 0 }}>
          <Button c="text.3" variant="subtle" onClick={handleLogout}>
            {t('HEADER.LOGOUT')}
          </Button>
        </Popover.Dropdown>
      </Popover>
    </Flex>
  );
};
